export const getSecureImage = (imgNum: number) => {
  switch (imgNum) {
    case 1:
      return "L1O7O3Bh"
    case 2:
      return "Z3ElHSTh"
    case 3:
      return "YDibjQUh"
    case 4:
      return "cj1MsFjh"
    case 5:
      return "y5QOoeQh"
    case 6:
      return "6MEVYNsh"
    case 7:
      return "Q9dA8oTh"
    case 8:
      return "Q9dA8oTh" //HERE
    case 9:
      return "4N0zFRzh"
    case 10:
      return "Go0WZzsh"
    case 11:
      return "y832qv8h"
    case 12:
      return "qfQAuN9h"
    case 13:
      return "O888WTgh"
    case 14:
      return "F2gaTWAh"
    case 15:
      return "NEJYj49h"
    case 16:
      return "E6jo9DSh"
    case 17:
      return "JR6ziebh"
    case 18:
      return "egkBFpAh"
    case 19:
      return "6OFpBoHh"
    case 20:
      return "CBvdi0Mh"
    case 21:
      return "RWvjH2Wh"
    case 22:
      return "JqbFyUXh"
    case 23:
      return "2Uql4mNh"
    case 24:
      return "R5lGlVTh"
    case 25:
      return "VW2GGcEh"
    case 26:
      return "bPuXpLBh"
    case 27:
      return "tvsT3gDh"
    case 28:
      return "Vf0ygd0h"
    case 29:
      return "GHBGJw4h"
    case 30:
      return "YgpFjpIh"
    case 31:
      return "6CVMsHTh"
    case 32:
      return "XMmbD8Uh"
    case 33:
      return "6gdD1CFh"
    case 34:
      return "3Hm7y66h"
    case 35:
      return "3PhQrsCh"
    case 36:
      return "v04PuPoh"
    case 37:
      return "WnchYb9h"
    case 38:
      return "PdZ6pn8h"
    case 39:
      return "6rxq0sHh"
    case 40:
      return "P81HEJnh"
    case 41:
      return "FVPmgTnh"
    case 42:
      return "bwyGG7ah"
    case 43:
      return "svzq8c1h"
    case 44:
      return "Kcfj3ZWh"
    case 45:
      return "DweADKzh"
    case 46:
      return "DweADKzh" //HERE
    case 47:
      return "GUCDiAQh"
    case 48:
      return "hyCxYk5h"
    case 49:
      return "ho7pnNZh"
    case 50:
      return "Rft8fVIh"
    case 51:
      return "x5shnImh"
    case 52:
      return "yWEWj4Th"
    case 53:
      return "TMVpVN2h"
    case 54:
      return "XaVzwjLh"
    case 55:
      return "mLGkyb9h"
    case 56:
      return "RYghTZSh"
    case 57:
      return "LV5ALvFh"
    case 58:
      return "pBc5LiGh"
    case 59:
      return "Xhtqc5kh"
    case 60:
      return "8jsYg1Gh"
    case 61:
      return "1lksSR0h"
    case 62:
      return "WZLelz7h"
    case 63:
      return "2K0wUZph"
    case 64:
      return "9UsIh1lh"
    case 65:
      return "4cgeloah"
    case 66:
      return "cLByqVyh"
    case 67:
      return "rAs6csKh"
    case 68:
      return "o9dErLph"
    case 69:
      return "nHUS1EMh"
    case 70:
      return "RgUuNl8h"
    case 71:
      return "2JEiGE0h"
    case 72:
      return "Ffimfxzh"
    case 73:
      return "LhK0k5zh"
    case 74:
      return "CtZAUkfh"
    case 75:
      return "qoR0qbkh"
    case 76:
      return "mz7px61h"
    case 77:
      return "xEs7AUxh"
    case 78:
      return "cKCNvmGh"
    case 79:
      return "VMwnFC9h"
    case 80:
      return "b5DyVWDh"
    case 81:
      return "zh9r5uJh"
    case 82:
      return "q5VrCrmh"
    case 83:
      return "hyORH5ah"
    case 84:
      return "dvj1luah"
    case 85:
      return "sO0jE7Rh"
    case 86:
      return "ySauru2h"
    case 87:
      return "dDvOsBbh"
    case 88:
      return "aeFHdY7h"
    case 89:
      return "OZdQ07oh"
    case 90:
      return "FEufoH9h"
    case 100:
      return "V8IzfiSh"
    case 101:
      return "m3tv2h4h"
    case 102:
      return "swWyZXIh"
    case 103:
      return "JiA9431h"
    case 104:
      return "ffH9bwbh"
    case 105:
      return "GwlZk4Bh"
    case 106:
      return "yR360uPh"
    case 107:
      return "BLga6Gdh"
    case 108:
      return "ukyr8t5h"
    case 109:
      return "B2w7thqh"
    case 110:
      return "4v0emmgh"
    case 111:
      return "gW9yZMuh"
    case 112:
      return "pVlXznQh"
    case 113:
      return "4WymHTMh"
    case 114:
      return "i8bkLGIh"
    case 115:
      return "XzRFy4Lh"
    case 116:
      return "kv3bmUmh"
    case 117:
      return "jijtvAQh"
    case 118:
      return "COL7iH4h"
    case 119:
      return "po7tRXKh"
    case 120:
      return "T8ilGeQh"
    case 121:
      return "OH6iPimh"
    case 122:
      return "drzNc3eh"
    case 123:
      return "cUQVkz7h"
    case 124:
      return "7bNiXODh"
    case 125:
      return "Uu6sKrhh"
    case 126:
      return "Qt97ynNh"
    case 127:
      return "viWJ8o2h"
    case 128:
      return "luld0ZHh"
    case 129:
      return "7Yq07fkh"
    case 130:
      return "1rnTMqrh"
    default:
      return "Z3ElHSTh"
  }
}
